<template>
  <div style = "width:100%;height:auto;">
    <CUploadField
      style = "width:100%;display:block;margin-bottom:5px;"
      v-for = "(item,index) in fileList"
      :key = 'index'
      :name = "item.fileName+'.' + item.fileType"
      :id = "item.attachmentId"
      :dele = 'dele'
      @on-delete = 'onDele'
    />
  </div>
</template>

<script>
export default {
  props: {
    ids: String,
    dele: Boolean,
    itemValue: Object
  },
  data(){
    return {
      fileList: []
    }
  },
  watch:{
    ids(val){
      if(val){
        this.getUploadFiles(val)
      }else{
        this.fileList = []
      }
    }
  },
  methods: {
    getUploadFiles(ids){
      this.$http.get(`/file/filemanage/getFilesByIds?attachmentIds=${ids}`).then(({data}) => {
        if(data.returnCode == 0&&data.beans.length){
          this.fileList = data.beans
          if(this.itemValue){
            this.$set(this.itemValue,'_itemValue',data.beans)
          }
          // this.itemValue._itemValue = data.beans
        }
      })
    },
    onDele(id){
      this.$emit('on-delete',id)
    }
  }
}
</script>

<style>

</style>